<template>
  <v-container fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="grey lighten-4" primary-title>
        <h2>Bem vindo(a) {{store.nome}}</h2>
      </v-card-title>
      <v-card-text>
        <div class="text-xs-center">
          <img src="../assets/logo.jpeg" class="imgresponsive"/>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onLogoutClick()" v-if="store.nome==''" >Acessar</v-btn>
        <v-btn small color="primary" @click="onLogoutClick()" v-if="store.nome!==''" >Sair</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import store from '../store'
import auth from '@/services/auth'
// import { showError } from '../utils'
// import requisicaoService from '@/services/requisicao'

export default {
  data () {
    return {
      auth,
      store,
      testReportButtonDisabled: false
    }
  },
  async mounted () {
    // auth.logout()
    // this.$router.push('/login')
  },
  methods: {
    onLogoutClick () {
      auth.logout()
      this.$router.push('/login')
    }
  }
}
</script>
<style>
.imgresponsive {
  max-width: 200px;
  width: 100%;
  height: auto;
}
</style>
